"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typeToTagMap = exports.setTextCssVars = exports.isChildrenNumberOrString = exports.getDefaultMargin = exports.LOREM = void 0;
var _parseCssValue = require("../../utils/parseCssValue");
/**
 * @copyright
 * Copyright (c) 2023 Accretive Technology Group, Inc. All rights
 * reserved. For use only by Accretive Technology, its employees
 * and contractors. DO NOT DISTRIBUTE.
 */

var LOREM = exports.LOREM = "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris elementum dui non bibendum convallis. In elementum sodales urna nec pellentesque. Aenean consequat odio nec risus porta fringilla. Morbi et viverra felis. Proin vel ante nec urna lobortis hendrerit.";
var typeToTagMap = exports.typeToTagMap = function typeToTagMap(type) {
  var _mapObject$type;
  var mapObject = {
    heading_2xl: "h1",
    heading_xl: "h1",
    heading_l: "h1",
    heading_m: "h2",
    heading_s: "h3",
    heading_xs: "h4",
    body_xl: "p",
    body_l: "p",
    body_m: "p",
    body_s: "p"
  };
  return (_mapObject$type = mapObject[type]) !== null && _mapObject$type !== void 0 ? _mapObject$type : "p";
};
var isChildrenNumberOrString = exports.isChildrenNumberOrString = function isChildrenNumberOrString(children) {
  return typeof children === "number" || typeof children === "string";
};
var getDefaultMargin = exports.getDefaultMargin = function getDefaultMargin(props) {
  if (typeof props.margin !== "undefined") {
    return {};
  }
  if (typeof props.marginTop === "undefined" && typeof props.marginRight === "undefined" && typeof props.marginBottom === "undefined" && typeof props.marginLeft === "undefined") {
    return {
      margin: 0
    };
  }
  return {
    marginTop: typeof props.marginTop === "undefined" && 0,
    // eslint-disable-next-line @atg/css-rtl-support
    marginRight: typeof props.marginRight === "undefined" && 0,
    marginBottom: typeof props.marginBottom === "undefined" && 0,
    // eslint-disable-next-line @atg/css-rtl-support
    marginLeft: typeof props.marginLeft === "undefined" && 0
  };
};
var setTextCssVars = exports.setTextCssVars = function setTextCssVars(options) {
  var styles = {};
  for (var key in options) {
    styles[key] = options[key];
    styles["--".concat(key)] = (0, _parseCssValue.parseCssValue)(options[key], key);
  }
  return styles;
};